module.exports = __webpack_public_path__ + "static/message-bg-bk-3b7d7a5bf9e88b0e6aa0fe465196aeaf.png";